var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.75 0C7.16421 0 7.5 0.335786 7.5 0.75V3H16.5V0.75C16.5 0.335786 16.8358 0 17.25 0C17.6642 0 18 0.335786 18 0.75V3H20.75C21.7165 3 22.5 3.7835 22.5 4.75V20.75C22.5 21.7165 21.7165 22.5 20.75 22.5H3.25C2.2835 22.5 1.5 21.7165 1.5 20.75V4.75C1.5 3.7835 2.2835 3 3.25 3H6V0.75C6 0.335786 6.33579 0 6.75 0ZM3.25 4.5C3.11193 4.5 3 4.61193 3 4.75V8H21V4.75C21 4.61193 20.8881 4.5 20.75 4.5H3.25ZM21 9.5H3V20.75C3 20.8881 3.11193 21 3.25 21H20.75C20.8881 21 21 20.8881 21 20.75V9.5Z",
    fill: "#111111"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.82121cb0.svg";
export { ForwardRef as ReactComponent };